import { render } from "./Show.vue?vue&type=template&id=6f8d3ac1"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"

import "./Show.vue?vue&type=style&index=0&id=6f8d3ac1&lang=scss"
script.render = render

export default script